import * as React from 'react';
import Tag from '../tag';
export default function PickerTag(props) {
    return React.createElement(Tag, Object.assign({ color: "blue" }, props));
}
